import { styled } from 'linaria/lib/react';

export const StyledListWrap = styled.div<{ isRight: boolean; hasBottomMargin?: boolean }>`
  padding-top: 14px;
  margin-left: ${({ isRight }) => (isRight ? 'auto' : 0)}px;
  margin-bottom: ${({ hasBottomMargin }) => (hasBottomMargin ? '8px' : 0)};
  width: 250px;
`;
